/* src/app/features/notas/pesquisa/listagem/notas-listagem.component.scss */
#col-acoes {
  width: 8%;
}
.letra-miuda {
  font-size: 14px;
  font-style: italic;
  text-align: bottom;
}
/*# sourceMappingURL=notas-listagem.component.css.map */
